import Main from "@/components/Base/Main";
import Home from "@/components/Dashboard/Home";
import RuleList from "@/components/Dashboard/Rules/List";
import RuleForm from "@/components/Dashboard/Rules/RuleForm";
import BudgetList from "@/components/Dashboard/Budgets/List";
import BudgetListTests from "@/components/Dashboard/Budgets/ListTests";
import EditEmail from "@/components/Dashboard/Budgets/EditEmail";
import BudgetListEditInfo from "@/components/Dashboard/Budgets/EditForm";

export default [
  {
    path: "/",
    name: "root",
    redirect: {
      name: "auth"
    },
    components: {
      main: Main
    },
    meta: {
      auth: true
    },
    children: [
      {
        name: "dashboard",
        path: "painel",
        component: Home,
        meta: {
          auth: true
        },
        children: [
          {
            name: "dashboard>rules",
            path: "regras",
            component: RuleList,
            meta: {
              auth: true
            }
          },
          {
            name: "dashboard>rules>edit",
            path: "regras/:id/editar",
            component: RuleForm,
            meta: {
              auth: true
            }
          },
          {
            name: "dashboard>budgets",
            path: "orcamentos",
            component: BudgetList,
            meta: {
              auth: true
            }
          },
          {
            name: "dashboard>budgetsTests",
            path: "orcamentos-testes",
            component: BudgetListTests,
            meta: {
              auth: true
            }
          },
          {
            name: "dashboard>editEmail",
            path: "edit-email",
            component: EditEmail
          },
          {
            name: "dashboard>budgetEditInfo",
            path: "edit-budget-form",
            component: BudgetListEditInfo,
            meta: {
              auth: true
            }
          }
        ]
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/router/modules/dashboard.js